import InnerHTML from 'dangerously-set-html-content'
import { Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { LRContainer } from 'style/styledItems'
import { AboutUsContainer } from './style'

function AboutUs() {
  const { t } = useTranslation()

  return (
    <AboutUsContainer className="h-100">
      <LRContainer className="section container">
        <div className="lr-content lr-item">
          <h2>{t('about_card1_title')}</h2>
          <h4>
            <InnerHTML html={t('about_card1_description')} />
          </h4>
        </div>
        <div className="lr-img lr-item">
          <Image src={'https://image.anecdobio.com/about_us_circle1.jpg'} />
        </div>
      </LRContainer>
      <div className="section">
        <LRContainer imgPos="R" className="container">
          <div className="lr-content lr-item">
            <h2>{t('about_card2_title')}</h2>
            <h4>
              <InnerHTML html={t('about_card2_description')} />
            </h4>
          </div>
          <div className="lr-img lr-item">
            <Image src={'https://image.anecdobio.com/about_us_circle2.jpg'} />
          </div>
        </LRContainer>
      </div>
      <LRContainer className="section container">
        <div className="lr-content lr-item">
          <h2>{t('about_card3_title')}</h2>
          <h4>
            <InnerHTML html={t('about_card3_description')} />
          </h4>
        </div>
      </LRContainer>
    </AboutUsContainer>
  )
}

export default AboutUs
